import React, { useEffect, useState } from "react";
import { useRoute } from "wouter";
import axios from "axios";
import { Check, CheckSquare } from "lucide-react";
import BASE_URL from "@/constants";

const UserInvite = () => {
  const [match, params] = useRoute("/po-user-invite/:userId");
  const userId = (params as any)?.userId;

  const [formData, setFormData] = useState({
    name: "",
    password: "",
    confirmPassword: "",
    company_name: "",
    role: "",
    email: "",
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [submitError, setSubmitError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [alreadyExist, setAlreadyExist] = useState(false);

  const getUserDetail = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/users/invite-status/${userId}`
      );

      if(response.data.message ==="User already exists" ){
        setAlreadyExist(true)
        return;
      }
      const { company_name, role, email } = response.data;

    
      setFormData((prev) => ({
        ...prev,
        company_name,
        role,
        email,
      }));
    } catch (err) {
      console.error(err);
      setError("Failed to fetch user details.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userId) {
      getUserDetail();
    }
  }, [userId]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setSubmitError("");
    setSuccessMessage("");
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Basic Validation
    if (formData.password.length < 8) {
      setSubmitError("Password must be at least 8 characters long.");
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setSubmitError("Passwords do not match.");
      return;
    }

    try {
      const response = await axios.post(BASE_URL+"/users/complete-onboarding", {
        userId,
        name: formData.name,
        password: formData.password,
      });

      setSuccessMessage(response.data.message || "Onboarding completed successfully.");
    } catch (err) {
      console.error(err);
      setSubmitError("Failed to complete onboarding.");
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-gray-600">Loading...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-red-600">{error}</p>
      </div>
    );
  }
  if(alreadyExist){
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
               
               <h1 className="text-purple-600 text-2xl">
                User already onboarded
                </h1> 
                
                 <Check className="h-10 w-10 text-info text-purple-600" />
        </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <form
        onSubmit={handleSubmit}
        className="bg-white p-8 rounded-2xl shadow-lg w-full max-w-md"
      >
        <h2 className="text-2xl font-semibold mb-6 text-gray-800">
          Complete Your Invite
        </h2>

        {submitError && <p className="text-red-600 mb-4">{submitError}</p>}
        {successMessage && <p className="text-green-600 mb-4">{successMessage}</p>}

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            className="mt-1 block w-full border border-gray-300 rounded-lg p-2 focus:ring-purple-500 focus:border-purple-500"
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Email</label>
          <input
            type="text"
            name="email"
            value={formData.email}
            readOnly
            className="mt-1 block w-full bg-gray-100 border border-gray-300 rounded-lg p-2 text-gray-600"
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Password</label>
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
            className="mt-1 block w-full border border-gray-300 rounded-lg p-2 focus:ring-purple-500 focus:border-purple-500"
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Confirm Password</label>
          <input
            type="password"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
            className="mt-1 block w-full border border-gray-300 rounded-lg p-2 focus:ring-purple-500 focus:border-purple-500"
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Company Name</label>
          <input
            type="text"
            name="company_name"
            value={formData.company_name}
            readOnly
            className="mt-1 block w-full bg-gray-100 border border-gray-300 rounded-lg p-2 text-gray-600"
          />
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700">Role</label>
          <input
            type="text"
            name="role"
            value={formData.role}
            readOnly
            className="mt-1 block w-full bg-gray-100 border border-gray-300 rounded-lg p-2 text-gray-600"
          />
        </div>

        <button
          type="submit"
          className="w-full bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-4 rounded-lg transition duration-200"
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default UserInvite;
